module.exports = __webpack_public_path__ + "img/sjjyk.6e302d81.png";